export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Rechercher',
  catalogHeaderTitle: 'Détails',
  catalogDetailsCurtainCopyOptionTitle: 'Copier le lien',
  catalogDetailsLinkCopiedAlertText: 'Lien copié !',
  catalogDetailsCurtainFlagOptionTitle: 'Signaler le contenu',
  catalogDetailsFlagCurtainTitle: 'Signaler',
  catalogReportedCurtainContent: 'Contenu signalé',
  catalogWantBuy: 'Veux acheter {item} de {app}',
  catalogInterestedIn: '{link}'
}
